import { Component, input, DOCUMENT, inject } from '@angular/core';

import { ApButtonLinkComponent } from '../link/link.component';

@Component({
    selector: 'ap-skip-link',
    templateUrl: './skip-link.component.html',
    imports: [ApButtonLinkComponent]
})
export class ApSkipLinkComponent {
    private readonly document = inject(DOCUMENT);

    /**
     * Optional HTMLElement to jump to. Defaults to first h1 tag on the page.
     */
    public readonly targetElement = input<HTMLElement>(undefined);

    protected activateSkipLink(e: MouseEvent): void {
        e.preventDefault();
        const targetElement = this.targetElement();
        if (targetElement) {
            this.focusElement(targetElement);
        } else {
            // Get the first <h1> on the page if there is no target element supplied
            const h1Element = this.document.getElementsByTagName('h1')[0];
            if (h1Element) {
                this.focusElement(h1Element);
            }
        }
    }

    private focusElement(element: HTMLElement): void {
        element.focus({ preventScroll: false });
        // Only interactive elements are focusable by default
        // If the element is not focused we add tabindex to be able to focus it
        if (this.document.activeElement !== element) {
            element.setAttribute('tabindex', '-1');
            element.focus({ preventScroll: false });
        }
    }
}
